import React, {useContext, useEffect, useRef, useState} from 'react';
import { Field } from 'react-final-form';
import Grid from "@material-ui/core/Grid";
import i18n, { Trans } from "../utils/i18n";
import {hasProducts} from "../config/orderEntryEnfore";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import {Button, IconButton, Modal} from "@mui/material";
import {CircularProgress, InputLabel, Typography} from "@material-ui/core";
import styled from "styled-components";
import RadioButton from "./RadioBig";
import FormControl from "@material-ui/core/FormControl";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import { flatten } from "lodash";
import TextInput from "./TextInput";
import classNames from "classnames";
import TextField from "@mui/material/TextField";
import map from "lodash/map";
import MuiSelect from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useGetProductCategories } from '../hooks/useOrderProductCategories';
import {ProductConfig, getProductConfigurationSteps} from "./ProductConfig";
import HelpModal from "./HelpModal";
import MuiButton from "@material-ui/core/Button";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import {getCookieValue} from "../utils/getCookieValue";
import ProblemSelectBig from "./ProblemSelectBig";
import dayjs from "dayjs";
import Datepicker from "./Datepicker";
import {useMutation} from "@tanstack/react-query";
import {usePage} from "@inertiajs/inertia-react";
import Checkbox from "./Checkbox";
import {useEmptyBoxConfigQuery} from "../FormComponents/EmptyBoxCheckbox";

export const ModalContent = styled.div`
    background-color: white;
    width: 100%;
    max-width: 70rem;
    max-height: 100vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
    outline: none;
    flex-wrap: wrap;
    padding: 3rem;
    overflow-y: scroll;

    @media (min-width: 768px) {
        margin-top: 10vh;
        width: 90%;
        max-height: calc(100vh - 15%);
    }
`;

export const SerialnumberDynamic = React.memo(function ({ values, form, productValues, amountOptions, disableColorSelection, validateSerialNumber, referenceFieldRequired = false }) {
        const orderEntryDispatch = useFormStateDispatch();
        const [modalOpen, setModalOpen] = useState(false);
        const products = values.products ?? [];
        const [error, setError] = useState(false);
        const { requesttypes, currentCountry, client } = usePage().props;
        const orderEntryState = useFormState();
        const { serialNumber: {product, success, }, selectedProduct, selectedCategory } = useFormState();

        const { data, isLoading, isError } = useEmptyBoxConfigQuery({
            requesttype: values.requesttype,
            product_id: product?.id,
        });
        const displayEmptyBoxCheckbox = !!data?.data?.empty_box_allowed;

        const postSerialnumberMutation = useMutation({
            mutationFn: (values, config) => axios.post(route('order.serialnumber'), values)
        });

        useEffect(() => {
            if(requesttypes.length === 1) {
                form.change('requesttype', requesttypes[0].key);
            }
        }, [requesttypes]);

        const PRODUCT_CONFIGURATION_STEPS = getProductConfigurationSteps(selectedCategory, values.model, disableColorSelection);

        const onEnter = (event) => {
            event.preventDefault();
            setError(false);
            postSerialnumberMutation?.reset();
            if(!values.serialnumber) {
                return;
            }

            if(products?.find(product => product.serialnumber === values.serialnumber)) {
                setError(i18n.t('orderEntry.serialNumber.alreadyTypedIn'));
                return;
            }

            return postSerialnumberMutation.mutate({
                serialnumber: values.serialnumber,
                type: values.requesttype,
                selectedProductId: selectedProduct?.id || undefined,
                pop_date: values.pop_date,
            }, {
                onSuccess: (data) => {
                    if(!data?.data.success) {
                        orderEntryDispatch({ type: 'setSerialNumber', value: {} });
                        return;
                    }
                    orderEntryDispatch({ type: 'setSerialNumber', value: data?.data });
                },
                onError: (data) => {
                    orderEntryDispatch({ type: 'setSerialNumber', value: {} });
                },
            })
        };

        return (
            <div className={'mt-9'}>
                <Grid container spacing={3} alignItems={'center'}>
                    <Grid item xs={12} sm={8}>
                        <h3
                            style={{
                                fontSize: 14,
                            }}>
                            <Trans i18nKey="orderEntry.productSelection">Product selection</Trans>
                        </h3>
                        <p>
                            <Trans i18nKey="orderEntry.productSelection.description"></Trans>
                        </p>
                    </Grid>
                    <Grid container item xs={12} sm={4} f justifyContent={'flex-end'} >
                        <Button
                            onClick={() => {
                                setModalOpen(true);
                            }}
                            variant="contained"
                            disabled={products.length >= 5}
                        >
                            <Trans i18nKey="orderEntry.addProduct">Add product</Trans>
                        </Button>
                    </Grid>
                </Grid>
                {
                    products.length > 0 && (
                        <hr style={{ marginBottom: 30 }}/>
                    )
                }
                <Grid container spacing={3}>
                    {
                        modalOpen &&
                        <Modal
                            open={true}
                            onClose={() => {
                                setModalOpen(false);
                            }}
                        >
                            <ModalContent>
                                <IconButton aria-label="delete" onClick={() => {
                                    setModalOpen(false);
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '1.5rem',
                                    right: '1.5rem',
                                }}>
                                    <CloseIcon />
                                </IconButton>
                                <div>
                                    {
                                        requesttypes.length > 1 && (
                                        <div>
                                            <div>
                                                <h3>
                                                    <Trans i18nKey="orderEntry.requestType">Request Type</Trans>
                                                </h3>
                                            </div>
                                            <Grid container spacing={3}>
                                                {
                                                    requesttypes
                                                        .map((item) =>
                                                            <Grid item xs={12} sm={6} key={item.id}>
                                                                <Field
                                                                    name={'requesttype'}
                                                                    type={'radio'}
                                                                    value={item.key}
                                                                    //placeholder={field.placeholder}
                                                                    component={RadioButton}
                                                                    validate={value => (value ? undefined : <Trans
                                                                        i18nKey="requestTypeSelect.required">Required</Trans>)}
                                                                    field={{
                                                                        titel: item.name,
                                                                        description: item.description,
                                                                        image: item.image,
                                                                    }}
                                                                />
                                                            </Grid>,
                                                        )
                                                }
                                            </Grid>
                                        </div>
                                    )}
                                    {
                                        values?.requesttype && <>
                                            <h3 className={'mb-6'}><Trans i18nKey={'orderEntry.model.pleaseSelect'}>Please
                                                select your model</Trans></h3>
                                            <ProductConfig
                                                values={values}
                                                form={form}
                                                productValues={values.products}
                                                disableColorSelection={disableColorSelection}
                                            />
                                        </>
                                    }

                                    {
                                        (PRODUCT_CONFIGURATION_STEPS.COLOR_SELECTION().enabled ? values?.color : values?.model) && (
                                            <div className={'flex-1 mt-6'}>
                                                <Field
                                                    name={'pop_date'}
                                                    type={'datepicker'}
                                                    component={Datepicker}
                                                    validate={value => {
                                                        return (value ? undefined :
                                                            <Trans i18nKey="serialNumber.required">Required</Trans>);
                                                    }}
                                                    field={{
                                                        "name": "pop_date",
                                                        "label": <Trans i18nKey="orderEntry.pop_date">Date of
                                                            purchase</Trans>,
                                                        "size": "full",
                                                        "type": "datepicker",
                                                        "required": true,
                                                        "allowPast": true,
                                                        "allowToolbar": true,
                                                        "maxDate": dayjs().toISOString(),
                                                    }}
                                                />
                                            </div>
                                        )
                                    }

                                    {
                                        (PRODUCT_CONFIGURATION_STEPS.COLOR_SELECTION().enabled ? values?.color : values?.model) && values?.pop_date &&
                                        <div className={'flex gap-3 items-start max-w-xl mt-6'}>
                                            <div className={'flex-1'}>
                                                <Field
                                                    name={'serialnumber'}
                                                    type={'text'}
                                                    component={TextInput}
                                                    validate={value => {
                                                        if (validateSerialNumber) {
                                                            return validateSerialNumber(value);
                                                        }

                                                        return (value ? undefined :
                                                            <Trans i18nKey="serialNumber.required">Required</Trans>);
                                                    }}
                                                    field={{
                                                        label: <Trans i18nKey="serialNumber">Serial Number</Trans>,
                                                        type: 'uppercase',
                                                    }}
                                                    onEnter={onEnter}
                                                    disabled={product || success}
                                                />
                                                <HelpModal/>
                                            </div>
                                            {
                                                !success &&
                                                <MuiButton
                                                    variant="contained"
                                                    color={'secondary'}
                                                    onClick={onEnter}
                                                    id={'serialnumber-search'}
                                                    disabled={postSerialnumberMutation.isLoading}
                                                    size={'large'}
                                                    styled={{padding: '14px 22px',}}
                                                    startIcon={postSerialnumberMutation.isLoading &&
                                                        <CircularProgress size={14}/>}
                                                >
                                                    <Trans i18nKey="serialNumber.search">Search</Trans>
                                                </MuiButton>
                                            }
                                            {
                                                !!success &&
                                                <MuiButton
                                                    variant="contained"
                                                    color={'secondary'}
                                                    onClick={() => {
                                                        orderEntryDispatch({type: 'setSerialNumber', value: {}});
                                                        setError(false);
                                                        form.mutators.addCompany(null)
                                                        form.mutators.addCoverageId(null)
                                                        form.mutators.setAddressId(null)
                                                    }}
                                                    id={'serialnumber-search'}
                                                    // disabled={manualDeviceSelection}
                                                    size={'large'}
                                                    styled={{padding: '14px 22px',}}
                                                    startIcon={<ChangeCircleIcon/>}
                                                >
                                                    <Trans i18nKey="serialNumber.change">Change</Trans>
                                                </MuiButton>
                                            }
                                        </div>
                                    }
                                    {
                                        (PRODUCT_CONFIGURATION_STEPS.COLOR_SELECTION().enabled ? values?.color : values?.model) && values?.pop_date && (postSerialnumberMutation?.isError || error) && (
                                            <div className={'flex justify-center mt-6'}>
                                                <div
                                                    className={'p-6 max-w-2xl b2x-shadow-md rounded-lg mt-3 flex flex-col justify-center items-center gap-1 bg-red-100 text-center'}>
                                                    <h3 className={'font-bold text-lg m-0'}>
                                                        {postSerialnumberMutation?.error?.response?.data?.message || error}
                                                    </h3>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        orderEntryState?.serialNumber?.product && (<>
                                                <h2 style={{marginBottom: 0}}><Trans i18nKey={'orderEntry.problem.heading'}>What
                                                    happend?</Trans></h2>
                                                <p><Trans i18nKey="orderEntry.problemDescription.description">Tell us about
                                                    the problem. Select a category to continue</Trans></p>
                                                <ProblemSelectBig
                                                    values={values}
                                                    addCompany={form.mutators.addCompany}
                                                    addCoverageId={form.mutators.addCoverageId}
                                                    setAddressId={form.mutators.setAddressId}
                                                    form={form}
                                                    // hideProblemInput={field.hideProblemInput}
                                                    // warningClassName={field.warningClassName}
                                                />
                                            </>
                                        )
                                    }
                                    {
                                        (PRODUCT_CONFIGURATION_STEPS.COLOR_SELECTION().enabled ? values?.color : values?.model) && values?.pop_date && values?.problem_2 && orderEntryState?.serialNumber?.product && (
                                            <div className={'mt-6'}>
                                                <Field
                                                    name={'reference'}
                                                    type={'text'}
                                                    component={TextInput}
                                                    field={{
                                                        label: <Trans
                                                            i18nKey="orderEntry.orderdetail.reference.label">Reference</Trans>,
                                                        "required": referenceFieldRequired,
                                                    }}
                                                />
                                            </div>
                                        )
                                    }
                                    {
                                        (PRODUCT_CONFIGURATION_STEPS.COLOR_SELECTION().enabled ? values?.color : values?.model) && values?.pop_date && values?.problem_2 && orderEntryState?.serialNumber?.product && displayEmptyBoxCheckbox && (
                                            <div className={'mt-6'}>
                                                <Field
                                                    name={'send_empty_box'}
                                                    type={'checkbox'}
                                                    component={Checkbox}
                                                    field={{
                                                        label: <Trans i18nKey="orderEntry.send_empty_box.label">Please send
                                                            me an empty box.</Trans>,
                                                    }}
                                                />
                                            </div>
                                        )
                                    }

                                    {
                                        (PRODUCT_CONFIGURATION_STEPS.COLOR_SELECTION().enabled ? values?.color : values?.model) && values?.pop_date && values?.problem_2 && orderEntryState?.serialNumber?.product && (values?.reference || !referenceFieldRequired) && (
                                            <div className={'mt-6 w-full flex justify-end'}>
                                                <MuiButton
                                                    variant="contained"
                                                    color={'secondary'}
                                                    onClick={() => {
                                                        setModalOpen(false);
                                                        orderEntryDispatch({type: 'setSerialNumber', value: {}});

                                                        form.change(`products`, [...products, {
                                                            id: selectedProduct.id,
                                                            amount: 1,
                                                            serialnumber: values.serialnumber,
                                                            terminalId: '',
                                                            uuid: Math.random(0, 100000000),
                                                            selectedProduct: selectedProduct,
                                                            color: values.color,
                                                            response: orderEntryState?.serialNumber,
                                                            reference: values.reference,
                                                            pop_date: values.pop_date,
                                                            problem_1: values.problem_1,
                                                            problem_2: values.problem_2,
                                                            problem_description: values.problem_description,
                                                            requesttype: values.requesttype,
                                                            send_empty_box: values.send_empty_box && displayEmptyBoxCheckbox,
                                                        }]);
                                                        form.change(`color`, null);
                                                        form.change("model", null);
                                                        form.change("serialnumber", "");
                                                        form.change("problem_1", "");
                                                        form.change("problem_2", "");
                                                        form.change("problem_description", "");
                                                        form.change("reference", "");
                                                        form.change("pop_date", null);
                                                        form.change("send_empty_box", null);
                                                    }}
                                                    id={'serialnumber-search'}
                                                    size={'large'}
                                                >
                                                    <Trans i18nKey="common.add">Add</Trans>
                                                </MuiButton>
                                            </div>
                                        )
                                    }
                                </div>
                            </ModalContent>
                        </Modal>
                    }
                </Grid>
                <div>
                    <div className="mt-8 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle">
                                <table className="min-w-full">
                                    <thead>
                                    <tr>
                                        <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8"
                                        >
                                            <Trans i18nKey="orderEntry.requestType">Request type</Trans>
                                        </th>
                                        <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8"
                                        >
                                            <Trans i18nKey="common.serialNumber">Serial number</Trans>
                                        </th>
                                        <th scope="col"
                                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            <Trans i18nKey="Product">Product</Trans>
                                        </th>
                                        <th scope="col"
                                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            <Trans i18nKey="serialNumber.problem">Problem</Trans>
                                        </th>
                                        <th scope="col"
                                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            <Trans i18nKey="common.warranty">Warranty</Trans>
                                        </th>
                                        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6 lg:pr-8">
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className=" bg-white">
                                    {products.map((singleProduct) => {
                                        const problems = singleProduct?.response?.product?.problems || [];
                                        const currentProblem = problems.find(item => parseInt(singleProduct.problem_1) === item.id);
                                        const currentProblem2 = currentProblem && currentProblem.problems?.find(item => parseInt(singleProduct.problem_2) === item.id);

                                        return (
                                            <tr key={singleProduct.uuid}
                                                className={'border border-t-2 border-t-black border-solid'}>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                                                    {singleProduct?.requesttype}
                                                </td>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                                                    {singleProduct?.serialnumber}
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {
                                                        singleProduct?.selectedProduct?.description
                                                    }
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {
                                                        currentProblem2?.name
                                                    }
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {
                                                        singleProduct?.response?.warranty ? <Trans
                                                                i18nKey="orderEntry.serialDynamic.warranty">Warranty</Trans> :
                                                            <Trans i18nKey="orderEntry.serialDynamic.noWarranty">No
                                                                warranty</Trans>
                                                    }
                                                </td>
                                                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 lg:pr-8">
                                                    <IconButton aria-label="delete" onClick={() => {
                                                        form.change(`products`, products.filter((product, roundIndex) => product.uuid !== singleProduct.uuid));
                                                    }}>
                                                        <DeleteIcon/>
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

